import React, { FC } from "react";
import { Button } from "../../../Button/Button";
import { ModalLayout } from "../Modal";

interface GenericModalProps {
	onClose: () => void;
	isOpen: boolean;
	onSubmit?: () => void;
	heading?: string;
	description?: string;
	buttonLabel?: string;
	className?: string;
}

export const GenericModal: FC<GenericModalProps> = ({
	onClose,
	onSubmit,
	isOpen,
	heading,
	description,
	buttonLabel,
	className,
}) => {
	return (
		<ModalLayout
			onClose={onClose}
			isOpen={isOpen}
			heading={heading}
			className={className}
		>
			{description && <div dangerouslySetInnerHTML={{ __html: description }} />}
			{buttonLabel && (
				<Button
					className="GenericModal__button"
					type={onSubmit ? "submit" : "button"}
					onClick={onSubmit ?? onClose}
					size="large"
					fullWidth
				>
					{buttonLabel}
				</Button>
			)}
		</ModalLayout>
	);
};
